import { CommonFunctions } from '../static/common-functions';
import { v_DispatchStatusHistoryBus } from './v_DispatchStatusHistoryBus';
import { DispatchesService } from '../services/dispatches.service';
import { Subscription } from 'rxjs';
import { DispatchBus } from './DispatchBus';
import { BasePage } from './BasePage';
import { ConstructionService } from '../services/construction.service';
import { v_DispatchNoteBus } from './v_DispatchNoteBus';
import { RelatedJobBus } from './RelatedJobBus';
import { ConstructionChartDetail } from './ConstructionChartDetail';
import { InvoiceDrawBus } from './InvoiceDrawBus';
import { BaseMessageInfo } from './BaseMessageInfo';
import { CnstContractBus } from './CnstContractBus';
import { VendorCreditContractBus } from './VendorCreditContractBus';
import { v_OrderBus } from './v_OrderBus';
import { v_InvoiceBus } from './v_InvoiceBus';
import { CommonValues } from '../static/CommonValues';
import * as _ from 'lodash';
import { DispatchCostAdjustmentBus } from './DispatchCostAdjustmentBus';

export class CnstContractPage extends BasePage<ConstructionService>
{
    svc_data: ConstructionService;
    svc_disp: DispatchesService;
  constructor(svc_data: ConstructionService, data: CnstContractPage = null, svc_disp: DispatchesService = null)
  {
      super();
      this.svc_data = svc_data;
      this.svc_disp = svc_disp;
    if (data !== null) {
      this.dispatchId = data.dispatchId;
      this.dispatch = data.dispatch;
        this.statusHistory = data.statusHistory;
        this.vendorCredits = data.vendorCredits;
    }
  }

 clear() {
     this.unsubscribe();
     this.dispatchId = null;
     this.dispatch = null;
     this.statusHistory = null;
     this.jobChangeOrders = [];
     this.jobChangeOrdersSOW = [];
     this.jobManWarranties = [];
     this.jobPostWarranties = [];
     this.jobChangeRequests = [];
     this.relatedJobs = [];
     this.costCompare = [];
     this.invoiceDraws = [];
     this.notes = [];
     this.dispatchCostAdjustments = [];
//     this.quotes = null;
//     this.invoices = null;
     this.notesLoading = false;
     this.statusHistoryLoading = false;
     this.vendorCreditsLoading = false;
     this.jobChangeOrdersLoading = false;
     this.jobManWarrantiesLoading = false;
     this.jobPostWarrantiesLoading = false;
     this.jobChangeRequestsLoading = false;
     this.costCompareLoading = false;
     this.invoiceDrawsLoading = false;
     this.dispatchCostAdjustmentsLoading = false;
 }
  unsubscribe() {
    CommonFunctions.unsubscribe(this.subs_statusHist);
      CommonFunctions.unsubscribe(this.subs_vendorCredits);
      CommonFunctions.unsubscribe(this.subs_notes);
      CommonFunctions.unsubscribe(this.subs_contractInfoOther);
      CommonFunctions.unsubscribe(this.subs_orders);
      CommonFunctions.unsubscribe(this.subs_jobCosts);
      CommonFunctions.unsubscribe(this.subs_dispatchCostAdjustments);

  }

    subs_statusHist: Subscription;
    subs_vendorCredits: Subscription;
    subs_notes: Subscription;
    subs_orders: Subscription;
    subs_contractInfoOther: Subscription;
    subs_invoices: Subscription;
    subs_jobCosts: Subscription;
    subs_dispatchCostAdjustments: Subscription;

    getStatusHistory(id: any) {
        this.statusHistoryLoading = true;
        CommonFunctions.unsubscribe(this.subs_statusHist);
      this.subs_statusHist = this.svc_disp.GetDispatchStatusHistory(id).subscribe(data => {
      this.statusHistory = data;
          this.statusHistoryLoading = false;
}
    )
  };
    getVendorCreditsByContract(id: any) {
        this.vendorCreditsLoading = true;
        CommonFunctions.unsubscribe(this.subs_vendorCredits);
        this.subs_vendorCredits = this.svc_data.getVendorCreditsByContract(id).subscribe((info: BaseMessageInfo) => {
            let arr = [];
            if (!info.saveError) {
                for (let i = 0; i < info.primaryReturn.length; i++) {
                    let newObj: VendorCreditContractBus = new VendorCreditContractBus(info.primaryReturn[i]);
                    arr.push(newObj);
                }
            }
            this.vendorCredits = arr;
            this.vendorCreditsLoading = false;
        });
    }

    getNotes(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.notesLoading = true;
            CommonFunctions.unsubscribe(this.subs_notes);
            this.subs_notes = this.svc_disp.getNotesView(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data)) {
                    for (let i = 0; i < data.length; i++) {
                        let newObj: v_DispatchNoteBus = new v_DispatchNoteBus(data[i]);
                        arr.push(newObj);
                    }
                }
                this.notes = arr;
                this.notesLoading = false;
            });
        }
        else {
            this.notes = [];
        }
    }
    getInvoices(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.invoicesLoading = true;
            CommonFunctions.unsubscribe(this.subs_invoices);
            this.subs_invoices = this.svc_data.getInvoicesByContract(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data.primaryReturn)) {
                    for (let i = 0; i < data.primaryReturn.length; i++) {
                        let newObj: v_InvoiceBus = new v_InvoiceBus(data.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.invoices = arr;
                this.invoicesLoading = false;
            });
        }
        else {
            this.notes = [];
        }
    }

    getContactJobCosts(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.invoicesLoading = true;
            CommonFunctions.unsubscribe(this.subs_jobCosts);
            this.subs_jobCosts = this.svc_data.getContactJobCosts(id).subscribe(data => {
                let arr = [];
                //if (CommonFunctions.hasArrayValue(data.primaryReturn)) {
                //    for (let i = 0; i < data.primaryReturn.length; i++) {
                //        let newObj: v_InvoiceBus = new v_InvoiceBus(data.primaryReturn[i]);
                //        arr.push(newObj);
                //    }
                //}
                this.jobCosts = data.dcValues.jobs;
                this.jobCostRollups = data.dcValues.jobRollups;

                this.jobCostsLoading = false;
            });
        }
        else {
            this.notes = [];
        }
    }
    getDispatchCostAdjustments(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.dispatchCostAdjustmentsLoading = true;
            CommonFunctions.unsubscribe(this.subs_dispatchCostAdjustments);
            this.subs_dispatchCostAdjustments = this.svc_data.getContractDispatchCostAdjustments(id).subscribe((info: BaseMessageInfo) => {
                let arr = [];
                if (CommonFunctions.hasValue(info) && !info.saveError && CommonFunctions.hasArrayElementValue(info.primaryReturn)) {
                    for (let i = 0; i < info.primaryReturn.length; i++) {
                        let newObj: DispatchCostAdjustmentBus = new DispatchCostAdjustmentBus(info.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.dispatchCostAdjustments = arr;
                this.dispatchCostAdjustmentsLoading = false;
            });
        }
        else {
            this.dispatchCostAdjustments = [];
        }
    }
    getOrdersByContract(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.ordersLoading = true;
            CommonFunctions.unsubscribe(this.subs_orders);
            this.subs_orders = this.svc_data.getOrdersByContract(id).subscribe(data => {
                let arr = [];
                if (CommonFunctions.hasArrayValue(data.primaryReturn)) {
                    for (let i = 0; i < data.primaryReturn.length; i++) {
                        let newObj: v_OrderBus = new v_OrderBus(data.primaryReturn[i]);
                        arr.push(newObj);
                    }
                }
                this.orders = arr.sort((a, b) => (a.supplierName > b.supplierName) ? 1 : ((b.supplierName > a.supplierName) ? -1 : ((a.orderNumber > b.orderNumber) ? 1 : ((b.orderNumber > a.orderNumber) ? -1 : 0))));
                this.openOrders = arr.filter((item) => { return (item.orderStatusId.toLowerCase() != CommonValues.Order_Completed && item.orderStatusId.toLowerCase() != CommonValues.Order_Canceled) });
                this.ordersLoading = false;
            });
        }
        else {
            this.orders = [];
            this.openOrders = [];
        }
    }

    getContractInfoOther(id: any) {
        this.jobChangeOrdersLoading = true;
        this.jobManWarrantiesLoading = true;
        this.jobPostWarrantiesLoading = true;
        this.jobChangeRequestsLoading = true;
        this.costCompareLoading = true;
        this.invoiceDrawsLoading = true;
        CommonFunctions.unsubscribe(this.subs_vendorCredits);
        this.subs_contractInfoOther = this.svc_data.getContractInfoOther(id).subscribe((info: BaseMessageInfo) => {
            let dataObj: CnstContractBus = new CnstContractBus(info.primaryReturn);
            this.jobChangeOrders = this.getRelatedJobBusArr(dataObj.jobChangeOrders);
            this.jobChangeOrdersSOW = this.jobChangeOrders.filter((value, index, self) => { return !value.isPassThrough && value.quoteStatusId === CommonValues.Quote_Pending });
            this.jobManWarranties = this.getRelatedJobBusArr(dataObj.jobManWarranties);
            this.jobPostWarranties = this.getRelatedJobBusArr(dataObj.jobPostWarranties);
            this.jobChangeRequests = this.getRelatedJobBusArr(dataObj.jobChangeRequests);
            this.costCompare = dataObj.costCompare;
            this.invoiceDraws = dataObj.invoiceDraws;

            this.jobChangeOrdersLoading = false;
            this.jobManWarrantiesLoading = false;
            this.jobPostWarrantiesLoading = false;
            this.jobChangeRequestsLoading = false;
            this.costCompareLoading = false;
            this.invoiceDrawsLoading = false;
        });

    }

    protected getRelatedJobBusArr(data: RelatedJobBus[]): RelatedJobBus[] {
        let arr = [];
        if (CommonFunctions.hasArrayValue(data)) {
            for (let i = 0; i < data.length; i++) {
                let newObj: RelatedJobBus = new RelatedJobBus(data[i]);
                arr.push(newObj);
            }
        }
        return arr;
    }
    getJobChangeOrders(id: any) {
        this.getContractInfoOther(id);
    }
    getJobManWarranties(id: any) {
        this.getContractInfoOther(id);
    }
    getJobPostWarranties(id: any) {
        this.getContractInfoOther(id);
    }
    getJobChangeRequests(id: any) {
        this.getContractInfoOther(id);
    }
    getCostCompare(id: any) {
        this.getContractInfoOther(id);
    }
    getInvoiceDraws(id: any) {
        this.getContractInfoOther(id);
    }

    get hasNotes(): boolean {
        return CommonFunctions.hasArrayElementValue(this.notes) || this.notesLoading;
    }
    get hasOrders(): boolean {
        return CommonFunctions.hasArrayElementValue(this.orders) || this.ordersLoading;
    }
  get hasStatusHist(): boolean {
      return CommonFunctions.hasArrayElementValue(this.statusHistory) || this.statusHistoryLoading;
    }
    get hasVendorCredits(): boolean {
        return CommonFunctions.hasArrayElementValue(this.vendorCredits) || this.vendorCreditsLoading;
    }
    get hasJobChangeOrders(): boolean {
        return CommonFunctions.hasArrayElementValue(this.jobChangeOrders) || this.jobChangeOrdersLoading;
    }
    get hasJobManWarranties(): boolean {
        return CommonFunctions.hasArrayElementValue(this.jobManWarranties) || this.jobManWarrantiesLoading;
    }
    get hasJobPostWarranties(): boolean {
        return CommonFunctions.hasArrayElementValue(this.jobPostWarranties) || this.jobPostWarrantiesLoading;
    }
    get hasJobChangeRequests(): boolean {
        return CommonFunctions.hasArrayElementValue(this.jobChangeRequests) || this.jobChangeRequestsLoading;
    }
    get hasCostCompare(): boolean {
        return CommonFunctions.hasArrayElementValue(this.costCompare) || this.costCompareLoading;
    }
    get hasInvoiceDraws(): boolean {
        return CommonFunctions.hasArrayElementValue(this.invoiceDraws) || this.invoiceDrawsLoading;
    }
    get hasInvoices(): boolean {
        return CommonFunctions.hasArrayElementValue(this.invoices) || this.invoicesLoading;
    }
    dispatchId: any;
    dispatch: DispatchBus;
    statusHistory: v_DispatchStatusHistoryBus[];
    vendorCredits: VendorCreditContractBus[];
    notes: v_DispatchNoteBus[];
    orders: v_OrderBus[]
    openOrders: v_OrderBus[];
    jobChangeOrders: RelatedJobBus[];
    jobChangeOrdersSOW: RelatedJobBus[];
    jobManWarranties: RelatedJobBus[];
    jobPostWarranties: RelatedJobBus[];
    jobChangeRequests: RelatedJobBus[];
    relatedJobs: RelatedJobBus[];
    costCompare: ConstructionChartDetail[];
    invoiceDraws: InvoiceDrawBus[];
    invoices: v_InvoiceBus[];
    jobCosts: any[];
    jobCostRollups: any[];
    dispatchCostAdjustments: DispatchCostAdjustmentBus[];
    statusHistoryLoading: boolean = false;
    vendorCreditsLoading: boolean = false;
    notesLoading: boolean = false;
    ordersLoading: boolean = false;
    jobChangeOrdersLoading: boolean = false;
    jobChangeRequestsLoading: boolean = false;
    jobManWarrantiesLoading: boolean = false;
    jobPostWarrantiesLoading: boolean = false;
    costCompareLoading: boolean = false;
    invoiceDrawsLoading: boolean = false;
    invoicesLoading: boolean = false;
    jobCostsLoading: boolean = false;
    dispatchCostAdjustmentsLoading: boolean = false;
}
